import { render, staticRenderFns } from "./BaseShell.vue?vue&type=template&id=575aaf8d&scoped=true"
import script from "./BaseShell.vue?vue&type=script&lang=js"
export * from "./BaseShell.vue?vue&type=script&lang=js"
import style0 from "./BaseShell.vue?vue&type=style&index=0&id=575aaf8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575aaf8d",
  null
  
)

export default component.exports